import { apiRequestActions } from '@ackee/redux-utils';
import { fetchContractsTypes } from './types';

export default apiRequestActions(fetchContractsTypes);
